"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Api_1 = require("./Api");
var Auth_1 = require("./Auth");
var Evergent_1 = require("../helpers/Evergent");
var PaymentMethods_1 = require("../helpers/PaymentMethods");
var Evergent = /** @class */ (function () {
    function Evergent(config) {
        this.api = Api_1.Api(config);
        this.apiKey = config.apiKey;
    }
    Evergent.prototype.getPaymentMethods = function () {
        var profileId = Auth_1.AuthStore.getUserId();
        var params = {
            GetPaymentMethodsRequestMessage: {
                apiKey: this.apiKey,
                channelPartnerID: "FOXUSA",
                cpCustomerID: profileId,
            },
        };
        return this.api
            .post("/getPaymentMethods", params, { token: true })
            .then(function (res) { return Evergent_1.resolveResponse(res, "GetPaymentMethodsResponseMessage"); })
            .then(PaymentMethods_1.parsePaymentMethods);
    };
    Evergent.prototype.changeService = function (_a) {
        var planId = _a.planId, couponCode = _a.couponCode, promotionId = _a.promotionId, paymentmethodInfo = _a.paymentmethodInfo, shippingAddress = _a.shippingAddress;
        var profileId = Auth_1.AuthStore.getUserId();
        var params = {
            ChangeServiceRequestMessage: {
                changeType: "Upgrade",
                apiKey: this.apiKey,
                channelPartnerID: "FOXUSA",
                cpCustomerID: profileId,
                couponCode: couponCode,
                promotionId: promotionId,
                newServiceID: planId,
                paymentmethodInfo: paymentmethodInfo,
                parameters: [
                    {
                        paramName: "Opertion Type",
                        paramValue: "Upgrade",
                    },
                ],
                shippingAddress: shippingAddress,
            },
        };
        return this.api
            .post("/changeService", params, { token: true })
            .then(function (res) { return Evergent_1.resolveResponse(res, "ChangeServiceResponseMessage"); });
    };
    Evergent.prototype.applyCoupon = function (couponCode) {
        var params = {
            ApplyCouponCodeRequestMessage: {
                apiKey: this.apiKey,
                channelPartnerID: "FOXUSA",
                couponCode: couponCode,
            },
        };
        return this.api
            .post("/applyCouponV2", params, { token: true })
            .then(function (res) { return Evergent_1.resolveResponse(res, "ApplyCouponCodeResponseMessage"); });
    };
    return Evergent;
}());
exports.Evergent = Evergent;
//# sourceMappingURL=Evergent.js.map